import { createGarmentContract } from '@/lib/patterns/contract';
import { buildJacketBlocks } from '@/lib/patterns/jacket/blocks';
import { JACKET_DISPLAY_OPTIONS } from '@/lib/patterns/jacket/displayOptions';
import { JACKET_DEFAULT_MEASUREMENTS } from '@/lib/patterns/jacket/defaults';
import {
  generateJacketPatternSIyV0,
  JACKET_V0_FORMULA_VERSION,
} from '@/lib/patterns/jacket/siy_v0';
import {
  generateJacketPatternSIyV1,
  JACKET_ACTIVE_FORMULA_VERSION,
  JACKET_V1_FORMULA_VERSION,
} from '@/lib/patterns/jacket/siy_v1';
import {
  JACKET_ACTIVE_GEOMETRY_VERSION,
  JACKET_GEOMETRY_V0,
  JACKET_GEOMETRY_V1,
  normalizeJacketGeometryVersion,
  resolveJacketFormulaVersionFromGeometry,
  resolveJacketGeometryVersionFromFormula,
  migrateJacketPatternForward,
} from '@/lib/patterns/jacket/version';

export { JACKET_GEOMETRY_V0, JACKET_GEOMETRY_V1, JACKET_ACTIVE_GEOMETRY_VERSION, normalizeJacketGeometryVersion };

export {
  JACKET_DEFAULT_MEASUREMENTS,
  JACKET_ACTIVE_FORMULA_VERSION,
  JACKET_V0_FORMULA_VERSION,
  JACKET_V1_FORMULA_VERSION,
};

export { JACKET_DISPLAY_OPTIONS };

export { resolveJacketGeometryVersionFromFormula, resolveJacketFormulaVersionFromGeometry, migrateJacketPatternForward };

export function generateJacketPattern(measurements, controls = {}) {
  const geometryVersion = normalizeJacketGeometryVersion(
    controls.geometryVersion || resolveJacketGeometryVersionFromFormula(controls.formulaVersion),
  );
  const formulaVersion = resolveJacketFormulaVersionFromGeometry(geometryVersion);

  const generated = (geometryVersion === JACKET_GEOMETRY_V0
    ? generateJacketPatternSIyV0
    : generateJacketPatternSIyV1)(measurements, {
    ...controls,
    geometryVersion,
    formulaVersion,
  });

  return {
    ...generated,
    formulaVersion,
    geometryVersion,
  };
}

export const computeJacket = generateJacketPattern;

export const JACKET_CONTRACT = createGarmentContract({
  garment: 'jacket',
  defaults: JACKET_DEFAULT_MEASUREMENTS,
  compute: computeJacket,
  version: JACKET_ACTIVE_GEOMETRY_VERSION,
  supportedVersions: [JACKET_GEOMETRY_V1, JACKET_GEOMETRY_V0],
  migrate: migrateJacketPatternForward,
  blocks: buildJacketBlocks,
  displayOptions: JACKET_DISPLAY_OPTIONS,
});
